import { withConnect } from './withConnect';
import { BareToolBoxMenu } from './ToolBoxMenu';

export const ToolBoxMenu = withConnect(BareToolBoxMenu);
